export default __webpack_public_path__ + "static/media/l2_data_voter_id.df2ac5ef.csv";